import { isSubscriptionExpired, isSubscriptionExpiringSoon, Vehicle } from '@agilox/common';
import { Component, computed, input } from '@angular/core';
import { SubscriptionNotifyType } from './enums/subscription-notify-type.enum';
import { SubscriptionNotifyComponent } from './subscription-notify/subscription-notify.component';

@Component({
	selector: 'subscription-notifies',
	templateUrl: './subscription-notifies.component.html',
	imports: [SubscriptionNotifyComponent],
})
export class SubscriptionNotifiesComponent {
	isInternalUser = input.required<boolean>();
	styleClass = input<string>('');
	userEmail = input<string>('');
	userName = input<string>('');
	vehicles = input.required<Vehicle[] | undefined>();

	expiredVehicles = computed(() => (this.vehicles() ?? []).filter(isSubscriptionExpired));

	expireSoonVehicles = computed(() => (this.vehicles() ?? []).filter(isSubscriptionExpiringSoon));

	visible = computed(
		() =>
			!this.isInternalUser() &&
			(this.expiredVehicles().length > 0 || this.expireSoonVehicles().length > 0)
	);

	protected readonly SubscriptionNotifyType = SubscriptionNotifyType;
}
